import * as Yup from "yup";
import { dateToyyyyMMdd } from "../../../util/date";
import { getPatchOperations } from "../../../util/form";

export const personDisciplinaerStatusForm = (
  disciplinaerStatusId: string,
  personId: string,
) => {
  const config: FormConfig<PersonDisciplinaerStatusDTO> = {
    title: "disciplinærstatus",
    lockedValues: [
      {
        id: "disciplinaerStatusId",
        value: disciplinaerStatusId,
      },
      {
        id: "personId",
        value: personId,
      },
    ],
    form: [
      {
        component: "kode-select",
        id: "disciplinaerstatusTypeNr",
        kodeListeType: "Disciplinaerstatustype",
        label: "Status",
        placeholder: "Vælg disciplinærstatus",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeFraDato",
        label: "Startdato",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeTilDatoInklusiv",
        label: "Slutdato",
        initialValue: "",
        undefinedValue: "9999-12-31",
      },
      {
        component: "textinput",
        id: "esdhSagsNr",
        label: "Sagsnr. F2",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "textinput",
        id: "bemaerkning",
        label: "Bemærkning",
        initialValue: "",
      },
    ],
    validationSchema: Yup.object({
      disciplinaerstatusTypeNr: Yup.string().required("Status skal være sat"),
      periodeFraDato: Yup.date().nullable().required("Startdato skal være sat"),
      periodeTilDatoInklusiv: Yup.date().nullable(),
      esdhSagsNr: Yup.string().required("Sagsnr skal være sat"),
    }),
    get: `person/${personId}/disciplinaerstatuser/${disciplinaerStatusId}`,
    patch(values: PersonDisciplinaerStatusDTO) {
      const ops = getPatchOperations(values);

      return {
        query: `person/${personId}/disciplinaerstatuser/${disciplinaerStatusId}`,
        body: JSON.stringify(ops),
      };
    },
    post(values: PersonDisciplinaerStatusDTO) {
      const {
        disciplinaerstatusTypeNr,
        esdhSagsNr,
        periodeFraDato,
        periodeTilDatoInklusiv,
        bemaerkning,
      } = values;
      return {
        query: `person/${personId}/disciplinaerstatuser/`,
        body: {
          disciplinaerstatusTypeNr,
          periodeFraDato: dateToyyyyMMdd(periodeFraDato),
          periodeTilDatoInklusiv: periodeTilDatoInklusiv
            ? dateToyyyyMMdd(periodeTilDatoInklusiv)
            : "9999-12-31",
          esdhSagsNr,
          bemaerkning,
        },
      };
    },
    delete() {
      return {
        query: `person/${personId}/disciplinaerstatuser/${disciplinaerStatusId}`,
      };
    },
  };
  return config;
};
